<!--
  name : 김혜진
  desc : (비회원)상세
  date : 2021-01-07
-->
<template>
  <div>
    <v-card v-model="dialogIdtest" id="navNcon" class="guest scrollYst">
      <v-row no-gutters class="mem_W_detail">
        <!-- 상세 상단 - 계약상태 / 최종수정일 / 파일명 / 계약요청/수신자 정보 / 인쇄, 다운로드 버튼 -->
        <v-card-title class="docuD_pop_title align-start">
          <div class="boxTcon">
            <div class="infoFCon">
              <!--계약 상태 ***상태별 텍스트 변경***  /*취소 / st01:검토 요청 / st02:내 서명 대기 / st03:서명 진행 / st04:서명 거부 / st05:완료 / st06:임시저장 **/-->
              <div
                class="carD_chip00"
                v-if="contractDetailInfo.contractStatus == 'CR' && !isSender"
              >
                <v-chip class="st02">내 서명 대기</v-chip>
              </div>
              <div
                class="carD_chip00"
                v-else-if="
                  contractDetailInfo.contractStatus == 'CR' && isSender
                "
              >
                <v-chip class="st02">서명 진행</v-chip>
              </div>
              <div
                class="carD_chip00"
                v-else-if="contractDetailInfo.contractStatus == 'CN'"
              >
                <v-chip class="st04">서명 거부</v-chip>
              </div>
              <div
                class="carD_chip00"
                v-else-if="contractDetailInfo.contractStatus == 'CC'"
              >
                <v-chip class="st05">완료</v-chip>
              </div>
              <div
                class="carD_chip00"
                v-else-if="contractDetailInfo.contractStatus == 'PR'"
              >
                <v-chip class="st01">검토 요청</v-chip>
              </div>
              <div
                class="carD_chip00"
                v-else-if="contractDetailInfo.contractStatus == 'PN'"
              >
                <v-chip class="st04">검토 거부</v-chip>
              </div>
              <div
                class="carD_chip00"
                v-else-if="contractDetailInfo.contractStatus == 'PC'"
              >
                <v-chip class="st05">승인 대기</v-chip>
              </div>
              <div
                class="carD_chip00"
                v-else-if="contractDetailInfo.contractStatus == 'DR'"
              >
                <v-chip class="st04">폐기 요청</v-chip>
              </div>
              <div
                class="carD_chip00"
                v-else-if="contractDetailInfo.contractStatus == 'DC'"
              >
                <v-chip class="st04">폐기 완료</v-chip>
              </div>
              <div
                class="carD_chip00"
                v-else-if="contractDetailInfo.contractStatus == 'DN'"
              >
                <v-chip class="st07">폐기 거부</v-chip>
              </div>
              <div class="carD_chip00" v-else>
                <v-chip class="st02">{{
                  contractDetailInfo.contractStatus
                }}</v-chip>
              </div>
              <!--↓ 파일명-->
              <div class="carD_01_txt">
                <!--계약명--><span class="st_tt_01">{{
                  contractDetailInfo.contractFileName
                }}</span>
                <!--↓ 최종수정일-->
                <div class="dateBox">
                  <span class="st_txt">{{
                    contractDetailInfo.sentDatetime
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="boxBtn">
            <!--↓ (버튼)파일을 인쇄함-->
            <!--<v-btn class="btn18_00" outlined @click="print()">
            <span class="btn-icon_print"></span>인쇄</v-btn>-->
            <!--↓ (버튼)파일을 다운로드함-->
            <v-btn class="btn18_00" outlined @click="downloadPDF()">
              <span class="btn-icon_download"></span>다운로드</v-btn
            >
            <!--↓ (버튼)팝업 닫음 - 비회원시 가리기
            <v-btn class="btn_pop_closeTop" icon @click="dialog = false, sheet = false">
            <span class="icon"></span>
            </v-btn>-->
          </div>

          <!-- 요청/수신자 정보 -->
          <v-col cols="12" class="docuD_pop_tcp_box">
            <ul
              class="pattern_ulTxtBox_conV"
              v-if="
                contractDetailInfo.contractStatus == 'CN' ||
                  contractDetailInfo.contractStatus == 'CC' ||
                  contractDetailInfo.contractStatus == 'DC' ||
                  contractDetailInfo.contractStatus == 'DN'
              "
            >
              <li>
                <!--↓ (고정)타이틀-->
                <span class="txt_icon">요청</span>
                <!--↓ (변동-타이틀 후에오는 모든 텍스트는 아래 class로 처리)회사이름-->
                <span class="txt_con">{{
                  contractDetailInfo.receiverName
                }}</span>
                <!--↓ (변동-타이틀 후에오는 모든 텍스트는 아래 class로 처리)이름-->
                <span
                  class="txt_icon"
                  v-if="contractDetailInfo.receiverBrokerName != null"
                  >요청 대행자</span
                >
                <span
                  class="txt_con"
                  v-if="contractDetailInfo.receiverBrokerName != null"
                  >{{ contractDetailInfo.receiverBrokerName }}</span
                >
              </li>
              <li>
                <span v-if="contractPath.length === 1">
                  <!--↓ (고정)타이틀-->
                  <span class="txt_icon">수신</span>
                  <!--↓ (변동-타이틀 후에오는 모든 텍스트는 아래 class로 처리)이름-->
                  <span class="txt_con">{{
                    contractDetailInfo.senderName
                  }}</span>
                  <span
                    class="txt_icon"
                    v-if="contractDetailInfo.senderBrokerName != null"
                    >수신 대행자</span
                  >
                  <span
                    class="txt_con"
                    v-if="contractDetailInfo.senderBrokerName != null"
                    >{{ contractDetailInfo.senderBrokerName }}</span
                  >
                </span>
                <span v-if="contractPath.length > 1">
                  <!-- 수신자 1명 이상일 경우 보이게 -->
                  <button
                    class="btn_guestV_dialog"
                    @click="dialogGuestV = true"
                  >
                    <span class="mr-2">+ 수신 {{ contractPath.length }}명</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      style="vertical-align:middle;"
                    >
                      <g fill="#fff" stroke="#f95f43" stroke-width="1">
                        <circle cx="10" cy="10" r="10" stroke="none" />
                        <circle cx="10" cy="10" r="9.5" fill="none" />
                      </g>
                      <g transform="translate(-205.806 -273.579)">
                        <path
                          d="M214.806,280.579l4,3.5-4,3.5"
                          transform="translate(0)"
                          fill="none"
                          stroke="#f95f43"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="1.2"
                        />
                      </g>
                    </svg>
                  </button>
                </span>
              </li>
            </ul>
            <ul class="pattern_ulTxtBox_conV" v-else>
              <li>
                <!--↓ (고정)타이틀-->
                <span class="txt_icon">요청</span>
                <!--↓ (변동-타이틀 후에오는 모든 텍스트는 아래 class로 처리)회사이름-->
                <span class="txt_con">{{ contractDetailInfo.senderName }}</span>
                <!--↓ (변동-타이틀 후에오는 모든 텍스트는 아래 class로 처리)이름-->
                <span
                  class="txt_icon"
                  v-if="contractDetailInfo.senderBrokerName != null"
                  >요청 대행자</span
                >
                <span
                  class="txt_con"
                  v-if="contractDetailInfo.senderBrokerName != null"
                  >{{ contractDetailInfo.senderBrokerName }}</span
                >
              </li>
              <li>
                <span v-if="contractPath.length === 1">
                  <!--↓ (고정)타이틀-->
                  <span class="txt_icon">수신</span>
                  <!--↓ (변동-타이틀 후에오는 모든 텍스트는 아래 class로 처리)이름-->
                  <span class="txt_con">{{
                    contractDetailInfo.receiverName
                  }}</span>
                  <span
                    class="txt_icon"
                    v-if="contractDetailInfo.receiverBrokerName != null"
                    >수신 대행자</span
                  >
                  <span
                    class="txt_con"
                    v-if="contractDetailInfo.receiverBrokerName != null"
                    >{{ contractDetailInfo.receiverBrokerName }}</span
                  >
                </span>
                <span v-if="contractPath.length > 1">
                  <!-- 수신자 1명 이상일 경우 보이게 -->
                  <button
                    class="btn_guestV_dialog"
                    @click="dialogGuestV = true"
                  >
                    <span class="mr-2">+ 수신 {{ contractPath.length }}명</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      style="vertical-align:middle;"
                    >
                      <g fill="#fff" stroke="#f95f43" stroke-width="1">
                        <circle cx="10" cy="10" r="10" stroke="none" />
                        <circle cx="10" cy="10" r="9.5" fill="none" />
                      </g>
                      <g transform="translate(-205.806 -273.579)">
                        <path
                          d="M214.806,280.579l4,3.5-4,3.5"
                          transform="translate(0)"
                          fill="none"
                          stroke="#f95f43"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="1.2"
                        />
                      </g>
                    </svg>
                  </button>
                </span>
              </li>
            </ul>
          </v-col>
          <!-- /요청/수신자 정보 -->
          <!-- 기타 정보 -->
          <v-col cols="12" class="pd-0">
            <ul class="pattern_ulTxtBox li_mg01">
              <li
                v-if="
                  contractDetailInfo.rejectMessage !== null &&
                    contractDetailInfo.rejectMessage !== undefined &&
                    contractDetailInfo.contractStatus == 'CN'
                "
              >
                <span class="txt_tt03 fc_C05">[거부사유]</span>
                <span class="txt_txt01">{{
                  contractDetailInfo.rejectMessage
                }}</span>
              </li>
              <li v-if="existDestoryMsg">
                <span class="txt_tt03 fc_C05">[폐기사유]</span>
                <span class="txt_txt01">{{
                  contractDetailInfo.destoryMessage
                }}</span>
              </li>
              <li class="info_requestor" v-if="attachedFiles.length <= 0">
                <span class="txt_tt03">[첨부파일]</span>
                <span class="txt_txt01">첨부파일이 없습니다.</span>
              </li>
              <li
                class="info_requestor"
                v-else
                v-for="(item, index) in attachedFiles"
                :key="index"
                @click.prevent="downloadAttachFile(item)"
              >
                <span class="txt_tt03">[첨부파일]</span>
                <a class="a_file_down" href="#" target="_blank">
                  <span class="txt_txt01">{{ item.fileName }}</span>
                  <span class="txt_txt03 no_pr">{{
                    item.fileSize | fileSizeFilter
                  }}</span>
                  <span class="icon_down"></span>
                </a>
              </li>
            </ul>
          </v-col>
          <!-- /기타 정보 -->
        </v-card-title>
        <!-- <contract-info :signal="signal" :contractDetailInfo="contractDetailInfo === null?'':contractDetailInfo"  :attachedFiles="attachedFiles"></contract-info>-->
        <!-- /상세 상단 -->
        <!-- 내용 -->
        <v-card-text class="docuD_pop_con">
          <v-row no-gutters>
            <!-- 미리보기 -->
            <v-col class="docuDpreVCol" cols="12" sm="12" md="12" lg="6">
              <div class="docuDpreVbox">
                <!--↓ height 고정용 class. 실제 작업시 삭제
              :부모태그의 height값이 아래 태그의 고정값으로 먹히므로 반드시 아래 태그 내용혹은 height값 필요 -->
                <pdf-preview
                  v-show="contract"
                  ref="pdfPreview"
                  :scale="1"
                  :key="componentKey"
                ></pdf-preview>
              </div>
            </v-col>
            <!-- /미리보기 -->
            <v-col class="docuDcon02Col" cols="12" sm="12" md="12" lg="6">
              <v-row no-gutters class="gridM_left30 gridM_left0_md w100h100">
                <!-- 각지정보 - 모바일에서는 디폴트-닫힘 -->
                <v-col class="docuDcmtBox" cols="12">
                  <v-card-actions class="fabS44">
                    <v-list-item-title class="fs18_fc98"
                      >갑지정보</v-list-item-title
                    >
                    <v-spacer></v-spacer>
                    <v-btn fab @click="show1 = show1 ? false : true">
                      <!--내용이 닫혀 있을 때 아이콘-->
                      <span class="icon_arr_s_g_u" v-if="show1"></span>
                      <!--내용이 열려 있을 때 아이콘-->
                      <span class="icon_arr_s_g_d" v-else></span>
                    </v-btn>
                  </v-card-actions>
                  <v-expand-transition>
                    <v-card-text v-show="show1">
                      <!-- 각지정보 내용 -->
                      <div v-if="subInfo <= 0">
                        <ul class="subinfoPCon">
                          <li>
                            부가정보가 없습니다.
                          </li>
                        </ul>
                      </div>
                      <div v-else>
                        <ul
                          class="subinfoPCon"
                          v-for="(info, index) in subInfo"
                          :key="index"
                        >
                          <li>
                            <!--↓ (고정)타이틀-->
                            <span class="txt_type_title">{{ info.key }}</span>
                            <!--↓ (고정)내용-->
                            <span class="txt_type_txt">{{ info.value }}</span>
                          </li>
                        </ul>
                      </div>
                      <!-- /각지정보 내용 -->
                    </v-card-text>
                  </v-expand-transition>
                </v-col>
                <!-- /각지정보 -->
                <!-- 계약로그 - 모바일에서는 디폴트-닫힘 -->
                <v-col class="docuDlogBox" cols="12">
                  <v-card-actions class="fabS44">
                    <v-list-item-title class="fs18_fc98"
                      >계약로그</v-list-item-title
                    >
                    <v-spacer></v-spacer>
                    <v-btn fab @click="show2 = show2 ? false : true">
                      <!--내용이 닫혀 있을 때 아이콘-->
                      <span class="icon_arr_s_g_u" v-if="show2"></span>
                      <!--내용이 열려 있을 때 아이콘-->
                      <span class="icon_arr_s_g_d" v-else></span>
                    </v-btn>
                  </v-card-actions>
                  <v-expand-transition>
                    <v-card-text class="box_log" v-show="show2">
                      <div v-if="contractHistory <= 0">
                        <ul class="subinfoPCon">
                          <li>
                            계약로그가 없습니다.
                          </li>
                        </ul>
                      </div>
                      <div v-else>
                        <ul
                          v-for="(history, index) in contractHistory"
                          :key="index"
                        >
                          <li>
                            <div
                              class="box_log_icon"
                              v-if="history.ctrStat == 'CR'"
                            >
                              <!--계약로그 상태 icon-->
                              <!--class=
                              (고정)log_cer_icon
                              (상태에 따라)
                              type01_01
                              CC 계약승인 | PC 검토승인 = type01_02 / CN 승인거부 = type01_03
                              CR 계약요청 = type02_01 / CA 계약요청 취소 = type02_02
                              검토요청 = type03_01 / PN 검토요청 거부 = type03_02
                              DW 다운로드 = type04_01 / LA 열람인증 = type04_02
                            -->
                              <!--계약로그 상태-->
                              <span class="log_cer_icon type02_01"></span>
                              <span class="txt_ing">{{
                                CtrRecord(history.ctrStat)
                              }}</span>
                            </div>
                            <div
                              class="box_log_icon"
                              v-else-if="
                                history.ctrStat == 'CC' ||
                                  history.ctrStat == 'PC'
                              "
                            >
                              <span class="log_cer_icon type01_02"></span>
                              <span class="txt_ing">{{
                                CtrRecord(history.ctrStat)
                              }}</span>
                            </div>
                            <div
                              class="box_log_icon"
                              v-else-if="history.ctrStat == 'CN'"
                            >
                              <span class="log_cer_icon type01_03"></span>
                              <span class="txt_ing">{{
                                CtrRecord(history.ctrStat)
                              }}</span>
                            </div>
                            <div
                              class="box_log_icon"
                              v-else-if="history.ctrStat == 'CA'"
                            >
                              <span class="log_cer_icon type02_02"></span>
                              <span class="txt_ing">{{
                                CtrRecord(history.ctrStat)
                              }}</span>
                            </div>
                            <div
                              class="box_log_icon"
                              v-else-if="history.ctrStat == 'PR'"
                            >
                              <span class="log_cer_icon type03_01"></span>
                              <span class="txt_ing">{{
                                CtrRecord(history.ctrStat)
                              }}</span>
                            </div>
                            <div
                              class="box_log_icon"
                              v-else-if="history.ctrStat == 'PN'"
                            >
                              <span class="log_cer_icon type03_02"></span>
                              <span class="txt_ing">{{
                                CtrRecord(history.ctrStat)
                              }}</span>
                            </div>
                            <div
                              class="box_log_icon"
                              v-else-if="history.ctrStat == 'DW'"
                            >
                              <span class="log_cer_icon type04_01"></span>
                              <span class="txt_ing">{{
                                CtrRecord(history.ctrStat)
                              }}</span>
                            </div>
                            <div
                              class="box_log_icon"
                              v-else-if="history.ctrStat == 'LA'"
                            >
                              <span class="log_cer_icon type04_02"></span>
                              <span class="txt_ing">{{
                                CtrRecord(history.ctrStat)
                              }}</span>
                            </div>
                            <div
                              class="box_log_icon"
                              v-else-if="history.ctrStat == 'DR'"
                            >
                              <span class="log_cer_icon type05_01"></span>
                              <span class="txt_ing">{{
                                CtrRecord(history.ctrStat)
                              }}</span>
                            </div>
                            <div
                              class="box_log_icon"
                              v-else-if="history.ctrStat == 'DC'"
                            >
                              <span class="log_cer_icon type05_02"></span>
                              <span class="txt_ing">{{
                                CtrRecord(history.ctrStat)
                              }}</span>
                            </div>
                            <div class="box_log_icon" v-else>
                              <span class="log_cer_icon type01_01"></span>
                              <span class="txt_ing">{{
                                CtrRecord(history.ctrStat)
                              }}</span>
                            </div>
                            <div class="box_log_txt">
                              <!--해당 담당자-->
                              <span class="txt_name">{{
                                history.crecDesc
                              }}</span>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </v-card-text>
                  </v-expand-transition>
                </v-col>
                <!-- /계약로그 -->
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <!-- /내용 -->
        <v-card-actions v-if="sheet" class="justify-center docu_btnCon">
          <div v-if="contractDetailInfo.contractStatus === 'CR'">
            <v-btn
              class="btn19_00 btnC_00"
              @click="chainAuthVisible('downloadCC')"
              >계약승인</v-btn
            >
            <v-btn class="btn19_00 btn_ol_C05" @click="chainAuthVisible('CN')"
              >승인거부</v-btn
            >
          </div>
          <div v-else-if="contractDetailInfo.contractStatus === 'PR'">
            <v-btn
              class="btn19_00 btnC_00"
              @click="chainAuthVisible('downloadPC')"
              >검토승인</v-btn
            >
            <v-btn class="btn19_00 btn_ol_C05" @click="chainAuthVisible('PN')"
              >검토거부</v-btn
            >
          </div>
          <div v-else-if="contractDetailInfo.contractStatus === 'DR'">
            <v-btn class="btn19_00 btnC_00" @click="chainAuthVisible('DC')"
              >폐기승인</v-btn
            >
            <!-- <v-btn class="btn19_00 btn_ol_C05" @click="chainAuthVisible('DN')"><span class="icon_cancel" ></span>폐기거부</v-btn> -->
          </div>
          <div
            v-else-if="
              contractDetailInfo.contractStatus === 'CC' &&
                contractDetailInfo.contractNumber.indexOf('NYM') >= 0
            "
          >
            <!-- <v-btn outlined class="btn19_00" @click="clickUploadFile">파일 첨부</v-btn> -->
            <input
              ref="fileInput"
              type="file"
              style="display:none"
              @change="changeUploadFile"
            />
          </div>
        </v-card-actions>
      </v-row>
    </v-card>
    <!--팝업-->
    <v-dialog v-model="dialogGuestV" max-width="600px" persistent>
      <v-card id="popStyle03">
        <v-card-title class="title">
          다자계약 수신 목록
          <v-btn fab class="popBtnClose" @click="dialogGuestV = false"></v-btn>
        </v-card-title>
        <v-card-text>
          <v-row no-gutters class="justify-center popCon">
            <div class="guestPoplist_sum">
              총 {{ receiverStatusList.length }}명
            </div>
            <ul class="guestPoplist_header">
              <li>
                <span class="txt_tt">수신자</span>
                <span class="txt_con">수신 대행자</span>
                <span class="txt_sum">상태</span>
              </li>
            </ul>
            <div class="guestPoplist">
              <ul>
                <li
                  :class="receiverListClass(receiver.STATUS)"
                  v-for="receiver in receiverStatusList"
                  :key="receiver.SEQ"
                >
                  <span class="txt_tt"
                    ><font style="font-size:.9em;">{{
                      receiver.RCV_NM
                    }}</font></span
                  >
                  <span class="txt_con"
                    ><font style="font-size:.9em;">{{
                      receiver.RCV_BRK_NM
                    }}</font></span
                  >
                  <span class="txt_ing" v-if="receiver.STATUS === 0"
                    ><font style="font-size:.9em;">{{
                      receiver.STATUS | receiverStatus
                    }}</font></span
                  >
                  <span class="txt_ing" v-else>
                    <span class="icon"
                      ><font style="font-size:.9em;">{{
                        receiver.STATUS | receiverStatus
                      }}</font></span
                    >
                  </span>
                </li>
              </ul>
            </div>
          </v-row>
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn text @click="dialogGuestV = false">닫기</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--/팝업-->
    <s-confirm ref="confirm"></s-confirm>
    <s-loading ref="loading"></s-loading>
    <ctr-reqeust-dialog
      ref="ctrReqeustDialog"
      :contractDetailInfo="contractDetailInfo"
      :authDialog="authDialog"
      :convertedInfo="convertedInfo"
      :signal="signal"
      :purCertInfo="purCertInfo"
      @childs-event="close"
    ></ctr-reqeust-dialog>
    <pubCert
      ref="pubCert"
      :cert-regno="purCertInfo.certRegNo"
      :hash="purCertInfo.hash"
      @childs-event="purCertResult"
    ></pubCert>
    <chainPass
      ref="chainPass"
      :chain-address="this.contractDetailInfo.chainAddress"
      @chainPassEvent="chainPassResult"
    ></chainPass>
    <rejectMessage
      ref="rejectMessage"
      @rejectEvent="rejectResult"
    ></rejectMessage>
  </div>
</template>
<script>
import ctrReqeustDialog from "@/views/contractLock/components/ctrReqeustDialog";
import {
  getContractDetail,
  downloadFile,
  deleteContractThumbnail,
  changeStatus,
  changeStatusForReviewApprove,
  changeStatusForApprove,
  verifyChain,
  getContractRecord,
  uploadFile,
  sendAttachFile
} from "@/api/contractLock";
import { approvalContractNomem, rejectContractNomem } from "@/api/contractLock";
import PubCert from "@/components/pubCert";
import ChainPass from "@/components/chainPass";
import PdfPreview from "@/components/pdfPreview";
import RejectMessage from "@/components/rejectDialog";
import { setCtrSeq, getCtrSeq } from "@/utils/auth";

var URL = {
  thumbnail: process.env.VUE_APP_URL_THUMBNAIL,
  watermark: process.env.VUE_APP_URL_WATERMARK,
  insertBarcode: process.env.VUE_APP_URL_INSERT_BARCODE,
  fileDownload: process.env.VUE_APP_URL_FILE_DOWNLOAD,
  contractPageThumbnail: process.env.VUE_APP_URL_CONTRACT_PAGE_THUMBNAIL
};

export default {
  name: "detail",
  props: {
    contractNumber: String,
    contractSeq: Number,
    certRegNo: String
  },
  components: {
    ctrReqeustDialog,
    PubCert,
    ChainPass,
    RejectMessage,
    PdfPreview
  },
  filters: {
    // 용량에 따른 파일 크기 포맷 변경
    fileSizeFilter(fileSize) {
      var filterFileSize = 0;
      if (fileSize >= 1000000) {
        filterFileSize = parseInt(fileSize / 1000000) + "MB";
      } else if (fileSize >= 1000) {
        filterFileSize = parseInt(fileSize / 1000) + "KB";
      } else {
        filterFileSize = fileSize + "KB";
      }
      return filterFileSize;
    },
    // 수신자 체결 상태
    receiverStatus(status) {
      let statusStr = "";
      if (status) {
        switch (status) {
          case 0:
            statusStr = "";
            break;
          case 1:
            statusStr = "승인";
            break;
          case 2:
            statusStr = "거부";
            break;
          default:
            statusStr = "";
        }
        return statusStr;
      }
    }
  },
  data() {
    return {
      // 상세 다이얼로그
      dialogIdtest: true,
      // 다자계약 수신 목록 다이얼로그
      dialogGuestV: false,
      // 갑지정보 여닫
      show1: true,
      // 계약로그 여닫
      show2: true,
      // 하단 버튼 고정
      sheet: false,
      chainAuthDialog: false,
      ctrSeq: "",
      // 계약서 정보
      contractDetailInfo: {
        contSeq: "",
        contractNumber: "",
        contractFileName: "",
        senderName: "",
        receiverName: "",
        senderAddress: "",
        receiverAddress: "",
        senderBrokerName: "",
        receiverBrokerName: "",
        sentDatetime: "",
        chainAddress: "",
        chainPassword: "",
        contractFileLink: "",
        contractStatus: "",
        rejectMessage: "",
        destoryMessage: ""
      },
      // contractDetailInfo: null,
      // 기업계약인지 개인계약인지 여부 확인
      signal: "",
      // 부가정보 리스트
      subInfo: [],
      // 첨부 파일 리스트
      attachedFiles: [],
      contractHistory: [],
      // 계약서 썸네일
      contractThumbnail: {
        pageSize: null,
        thumbnail: []
      },
      // PDF로 변환된 파일 정보
      convertedInfo: {
        downloadTempPath: null,
        convertedCtrFileName: null,
        contractNumber: null
      },
      // 워터마크들
      watermarks: [],
      downloadParam: {
        chainAddr: null,
        chainPass: null,
        downloadUrl: null,
        contractNumber: null,
        contractStatus: null,
        contractFileName: null,
        gubun: null,
        receiverName: null,
        receiverAddress: null
      },
      // 워터마크 첨부 여부
      isWmAttach: false,
      url: {
        confirmDownloadURL: process.env.VUE_APP_URL_CONFIRM_DOWNLOAD_URL
      },
      downloadFileInfo: null,
      // 블록체인 인증 창 타이틀 / 인증자 / 알림 문구 / 상태변경 메시지 / 상태 플래그
      authDialog: {
        title: "",
        authUserText: "",
        warningText: "",
        changeStatusText: "",
        changeStatus: ""
      },
      pdfFileName: null,
      // swiper 옵션
      purCertInfo: {
        certRegNo: "",
        hash: ""
      },
      ctrInfo: {
        contractNumber: "",
        contractSeq: "",
        ctrLockType: "",
        failCnt: "",
        stat: "",
        signType: "",
        acqDate: "",
        resultCode: "",
        receiverName: null,
        receiverAddress: null
      },
      contract: {},
      componentKey: 0,
      contractPath: [],
      receiverStatusList: [],
      accessFileExtensions: [
        "doc",
        "docx",
        "xls",
        "xlsx",
        "ppt",
        "pptx",
        "pdf"
      ],
      existDestoryMsg: false
    };
  },
  created() {
    if (this.contractSeq !== undefined) {
      setCtrSeq(this.contractSeq);
    }
  },
  mounted() {
    this.track();
    this.$nextTick(() => {
      this.readDatas();
    });
  },
  methods: {
    track() {
      this.$gtag.pageview({
        page_path: "/contrackLockDetail"
      });
    },

    researchDatas() {
      this.contractDetailInfo.contSeq =
        this.contractSeq == null ? getCtrSeq() : this.contractSeq;
      getContractDetail({ ctrSeq: this.contractDetailInfo.contSeq * 1 })
        .then(response => {
          if (response.rdata.rcode === 20000) {
            this.getCtrBinding(response);
          } else if (response.rdata.rcode === 30011) {
            this.$refs.confirm.open(
              "alert",
              "계약상세",
              "계약상세 조회에 실패했습니다. ( 실패이유 - " +
                response.rdata.rmessage +
                " )"
            );
          } else {
            this.$refs.confirm.open(
              "alert",
              "계약상세",
              "계약상세 조회에 실패 에러 : " + response.rdata.rmessage
            );
          }
        })
        .catch(e => {
          console.log(e);
        });
    },

    getCtrBinding(response) {
      this.contractDetailInfo.contractNumber =
        response.rdata.detailInfo.contractNumber;
      this.contractDetailInfo.contractFileName =
        response.rdata.detailInfo.contractFileName;
      this.contractDetailInfo.senderName = response.rdata.detailInfo.senderName;
      this.contractDetailInfo.receiverName =
        response.rdata.detailInfo.receiverName;
      this.contractDetailInfo.senderBrokerName =
        response.rdata.detailInfo.senderBrokerName;
      this.contractDetailInfo.receiverBrokerName =
        response.rdata.detailInfo.receiverBrokerName;
      this.contractDetailInfo.sentDatetime =
        response.rdata.detailInfo.sentDatetime;
      this.contractDetailInfo.chainAddress =
        response.rdata.detailInfo.ownerAddress;
      this.contractDetailInfo.senderAddress =
        response.rdata.detailInfo.senderAddress;
      this.contractDetailInfo.receiverAddress =
        response.rdata.detailInfo.receiverAddress;
      this.contractDetailInfo.contractFileLink = response.rdata.fileHash;
      this.contractDetailInfo.signType = response.rdata.detailInfo.signType;
      this.contractDetailInfo.rejectMessage =
        response.rdata.detailInfo.rejectMessage;
      this.contractDetailInfo.id = response.rdata.detailInfo.id;
      this.purCertInfo.certRegNo = response.rdata.certRegNo;
      this.ctrInfo.stat = response.rdata.stat;
      this.contractPath = response.rdata.contractPath;
      this.receiverStatusList = response.rdata.receiverStatusList;

      if (
        response.rdata.detailInfo.ownerAddress ===
        response.rdata.detailInfo.senderAddress
      ) {
        if (
          response.rdata.detailInfo.senderBrokerName !== "" &&
          response.rdata.detailInfo.senderBrokerName !== null
        ) {
          this.downloadParam.receiverName =
            response.rdata.detailInfo.senderName +
            " " +
            response.rdata.detailInfo.senderBrokerName;
          this.downloadParam.receiverAddress =
            response.rdata.detailInfo.senderBrokerAddress;
        } else {
          this.downloadParam.receiverName =
            response.rdata.detailInfo.senderName;
          this.downloadParam.receiverAddress =
            response.rdata.detailInfo.ownerAddress;
        }
      } else if (
        response.rdata.detailInfo.ownerAddress ===
        response.rdata.detailInfo.receiverAddress
      ) {
        if (
          response.rdata.detailInfo.receiverBrokerName !== "" &&
          response.rdata.detailInfo.receiverBrokerName !== null
        ) {
          this.downloadParam.receiverName =
            response.rdata.detailInfo.receiverName +
            " " +
            response.rdata.detailInfo.receiverBrokerName;
          this.downloadParam.receiverAddress =
            response.rdata.detailInfo.receiverBrokerAddress;
        } else {
          this.downloadParam.receiverName =
            response.rdata.detailInfo.receiverName;
          this.downloadParam.receiverAddress =
            response.rdata.detailInfo.ownerAddress;
        }
      }

      this.contractDetailInfo.contractStatus =
        response.rdata.detailInfo.contractStatus;
      // this.contractDetailInfo = response.rdata.detailInfo
      this.signal = response.rdata.signal;
      this.isSender = response.rdata.isSender;
      // 첨부 파일은 없을 수도 있기 때문에 값이 있을 때만 넣어줘야함
      if (response.rdata.attachedFile) {
        this.attachedFiles = response.rdata.attachedFile;
      }
      this.contractHistory = response.rdata.contractHistory;
      // 부가 정보는 없을 수도 있기 때문에 값이 있을 때만 넣어줘야함
      if (response.rdata.subInfo) {
        this.subInfo = response.rdata.subInfo;
      }
      if (response.rdata.contractHistory) {
        this.contractHistory = response.rdata.contractHistory;
      }

      if (this.contractDetailInfo.contractNumber.startsWith("KRZ")) {
        if (
          this.contractDetailInfo.contractStatus == "DR" ||
          this.contractDetailInfo.contractStatus == "DC"
        ) {
          this.contractDetailInfo.destoryMessage =
            response.rdata.detailInfo.rejectMessage;

          this.existDestoryMsg = true;
        }
      }

      this.$nextTick(() => {
        if(this.contractDetailInfo.contractNumber.startsWith("KRH")) {
          if(response.rdata.stat == "CC") {
            if(response.rdata.auth_adr != response.rdata.detailInfo.ownerAddress) {
              console.log("비회원상태는 승인")
              this.contractDetailInfo.chainAddress =
                response.rdata.auth_adr;
            }
          }
        }
      })
    },

    readDatas() {
      this.contractDetailInfo.contSeq =
        this.contractSeq == null ? getCtrSeq() : this.contractSeq;
      getContractDetail({ ctrSeq: this.contractDetailInfo.contSeq * 1 })
        .then(response => {
          if (response.rdata.rcode === 20000) {
            this.getCtrBinding(response);

            this.$nextTick(() => {
              this.downloadAuthChain();
            })

          } else if (response.rdata.rcode === 30011) {
            this.$refs.confirm.open(
              "alert",
              "계약상세",
              "계약상세 조회에 실패했습니다. ( 실패이유 - " +
                response.rdata.rmessage +
                " )"
            );
          } else {
            this.$refs.confirm.open(
              "alert",
              "계약상세",
              "계약상세 조회에 실패 에러 : " + response.rdata.rmessage
            );
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    downloadPDF() {
      this.downloadParam.chainAddr = this.contractDetailInfo.chainAddress;
      this.downloadParam.chainPass = this.contractDetailInfo.chainPassword;
      this.downloadParam.downloadUrl = this.contractDetailInfo.contractFileLink;
      this.downloadParam.contractNumber = this.contractDetailInfo.contractNumber;
      this.downloadParam.contractFileName = this.contractDetailInfo.contractFileName;
      this.downloadParam.contractStatus = this.contractDetailInfo.contractStatus;
      this.downloadParam.gubun = "DW";
      this.$refs.loading.start("계약서 다운로드를 진행 중입니다.");
      downloadFile(this.downloadParam)
        .then(response => {
          this.$refs.loading.end();
          if (response.rdata.rcode === 20000) {
            window.open(
              this.url.confirmDownloadURL +
                "/" +
                this.downloadParam.gubun +
                "/" +
                response.rdata.convId +
                "/" +
                this.downloadParam.downloadUrl,
              "_blank"
            );
            this.getContractRecord();
          } else {
            this.$refs.confirm.open(
              "alert",
              "계약서 다운로드",
              "계약서 다운로드에 실패했습니다. ( error : " +
                response.rdata.rmessage +
                " )"
            );
          }
        })
        .catch(() => {
          this.$refs.loading.end();
          this.$refs.confirm.open(
            "alert",
            "계약서 다운로드",
            "계약서 다운로드에 실패했습니다."
          );
        });
    },
    downloadAuthChain() {
      this.$refs.loading.start("계약서 다운로드를 진행 중입니다.");
      this.downloadParam.chainAddr = this.contractDetailInfo.chainAddress;
      this.downloadParam.chainPass = this.contractDetailInfo.chainPassword;
      this.downloadParam.downloadUrl = this.contractDetailInfo.contractFileLink;
      this.downloadParam.contractNumber = this.contractDetailInfo.contractNumber;
      this.downloadParam.contractFileName = this.contractDetailInfo.contractFileName;
      this.downloadParam.contractStatus = this.contractDetailInfo.contractStatus;
      this.downloadParam.gubun = "PV";
      downloadFile(this.downloadParam)
        .then(response => {
          this.$refs.loading.end();
          if (response.rdata.rcode === 20000) {
            this.convertedInfo.downloadTempPath =
              response.rdata.downloadTempPath;
            this.convertedInfo.convertedCtrFileName = response.rdata.convId;
            this.convertedInfo.contractNumber = this.contractDetailInfo.contractNumber;
            var downFile =
              this.url.confirmDownloadURL +
              "/" +
              this.downloadParam.gubun +
              "/" +
              response.rdata.convId +
              "/" +
              this.downloadParam.downloadUrl;
            this.createContractThumbnail(downFile);
            this.getContractRecord();
            if (
              this.ctrInfo.stat === "CR" ||
              this.ctrInfo.stat === "PR" ||
              this.ctrInfo.stat === "DR" ||
              this.ctrInfo.stat === "CC"
            ) {
              if (this.ctrInfo.stat === "CC") {
                this.sheet = true;
              } else {
                if (!this.isSender) {
                  this.sheet = true;
                }
              }
            } else if (this.ctrInfo.stat === "CN") {
              this.$refs.confirm.open(
                "alert",
                "계약상세",
                "승인 거부된 계약입니다."
              );
            } else if (this.ctrInfo.stat === "PN") {
              this.$refs.confirm.open(
                "alert",
                "계약상세",
                "검토 거부된 계약입니다."
              );
            } else if (this.ctrInfo.stat === "PC") {
              this.$refs.confirm.open(
                "alert",
                "계약상세",
                "검토 승인된 계약입니다."
              );
            } else if (this.ctrInfo.stat === "DN") {
              this.$refs.confirm.open(
                "alert",
                "계약상세",
                "폐기 거부된 계약입니다."
              );
            } else if (this.ctrInfo.stat === "DC") {
              this.$refs.confirm.open(
                "alert",
                "계약상세",
                "폐기된 계약입니다."
              );
            }

            if (this.ctrInfo.stat === "CC") {
              this.$refs.confirm.open(
                "alert",
                "계약상세",
                "승인 처리된 계약입니다."
              );
            }
          } else if (response.rdata.rcode === 30011) {
            this.$refs.confirm.open(
              "alert",
              "계약서 다운로드",
              "계약서 다운로드 요청에 실패했습니다. ( 실패이유 - " +
                response.rdata.rmessage +
                " )"
            );
          } else {
            this.$refs.confirm.open(
              "alert",
              "계약서 다운로드",
              "계약서 다운로드 요청에 실패했습니다. 다시 시도하거나 관리자에게 문의해주세요."
            );
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    createContractThumbnail(downFile) {
      this.$nextTick(() => {
        this.$refs.pdfPreview.open(downFile);
      });
      /*
      this.$nextTick(() => {
        createContractThumbnail(JSON.stringify({ pdfFileName: this.convertedInfo.convertedCtrFileName })).then(response => {

          this.pdfFileName = this.convertedInfo.convertedCtrFileName

          console.log('this.convertedInfo.convertedCtrFileName===' + this.pdfFileName)
          this.$refs.pdfPreview.open(URL.contractPageThumbnail + this.pdfFileName)


          this.contractThumbnail.pageSize = response.rdata.pdfPageSize
          for (var i = 0; i < this.contractThumbnail.pageSize; i++) {
            this.watermarks[i] = []
          }
          this.$forceUpdate()
          this.getContractThumbnail()

        }).catch(e => {
          console.log(e)
        })

      })
      */
    },
    getContractThumbnail() {
      this.$refs.loading.end();
      this.contractThumbnail.thumbnail.splice(
        0,
        this.contractThumbnail.thumbnail.length
      );
      for (let i = 0; i < this.contractThumbnail.pageSize; i++) {
        this.contractThumbnail.thumbnail.push({
          url: URL.contractPageThumbnail + this.pdfFileName + "/" + i
        });
      }
      this.deleteContractThumbnail();
    },
    // 워터마크 다이얼로그를 닫았을 때 생성됐던 썸네일 폴더 및 하위 파일들을 삭제해주는 기능
    deleteContractThumbnail() {
      setTimeout(() => {
        deleteContractThumbnail(
          JSON.stringify({ pdfFileName: this.pdfFileName })
        )
          .then(response => {
            this.$forceUpdate();
          })
          .catch(e => {
            console.log(e);
          });
      }, 1000);
    },
    // 블록체인 인증 (승인 / 거부 / 취소 클릭 시)
    chainAuthVisible(changeStatus) {
      this.authDialog.changeStatus = changeStatus;
      // 블록체인 인증 창 상태값에 따른 텍스트 변경 및 블록체인 인증 창 활성화
      if (changeStatus === "CN") {
        this.authDialog.title = "계약승인 거부";
        this.authDialog.authUserText = "계약 수신자";
        this.authDialog.warningText =
          "블록체인 인증이 완료되어야 승인거부가 완료 됩니다.";
        this.authDialog.changeStatusText = "계약승인 거부 중입니다.";
        this.authDialog.endMessage = "계약승인이 거부 되었습니다.";
        this.purCertInfo.hash = "asdfasdfafa";
        this.$refs.rejectMessage.open();
      } else if (changeStatus === "downloadCC") {
        this.authDialog.title = "계약승인";
        this.authDialog.authUserText = "계약 수신자";
        this.authDialog.warningText =
          "원본계약서 확인과 계약승인을 위해 두번의 블록체인 인증이 필요합니다.";
        this.authDialog.changeStatusText = "계약서 다운로드 요청중입니다.";
        this.$refs.ctrReqeustDialog.open();
      } else if (changeStatus === "downloadPC") {
        this.authDialog.title = "검토승인";
        this.authDialog.authUserText = "검토 수신자";
        this.authDialog.warningText =
          "원본계약서 확인과 검토승인을 위해 두번의 블록체인 인증이 필요합니다.";
        this.authDialog.changeStatusText = "계약서 다운로드 요청중입니다.";
        this.$refs.ctrReqeustDialog.open();
      } else if (changeStatus === "PC") {
        this.authDialog.title = "검토승인";
        this.authDialog.authUserText = "검토 수신자";
        this.authDialog.warningText =
          "블록체인 인증이 완료되어야 검토승인 후 계약요청이 완료됩니다.";
        this.authDialog.changeStatusText = "검토 승인 후 계약요청 중입니다.";
        this.authDialog.endMessage =
          "검토승인후 계약요청이 완료 되었습니다. 미처리함으로 이동합니다.";
        this.$refs.ctrReqeustDialog.open();
      } else if (changeStatus === "PN") {
        this.authDialog.title = "검토승인 거부";
        this.authDialog.authUserText = "검토 수신자";
        this.authDialog.warningText =
          "블록체인 인증이 완료되어야 검토승인 거부가 완료 됩니다.";
        this.authDialog.changeStatusText = "검토승인 거부 중입니다.";
        this.authDialog.endMessage =
          "검토승인이 거부되었습니다. 보관함으로 이동합니다.";
        this.$refs.rejectMessage.open();
      } else if (changeStatus === "DC") {
        this.authDialog.title = "폐기승인";
        this.authDialog.authUserText = "폐기요청 수신자";
        this.authDialog.warningText =
          "블록체인 인증이 완료되어야 계약폐기 승인이 완료 됩니다.";
        this.authDialog.changeStatusText = "계약폐기 승인 중입니다.";
        this.authDialog.endMessage =
          "계약서가 폐기되었습니다. 보관함으로 이동합니다.";
        this.$refs.ctrReqeustDialog.open();
      }
    },
    print() {
      window.print();
    },
    downloadAttachFile(item) {
      this.downloadFileInfo = item;
      this.$refs.loading.start("첨부파일 다운로드 요청중입니다.");
      this.downloadParam.chainAddr = this.contractDetailInfo.chainAddress;
      this.downloadParam.chainPass = this.contractDetailInfo.chainPassword;
      this.downloadParam.downloadUrl = this.downloadFileInfo.fileLink;
      this.downloadParam.contractNumber = this.contractDetailInfo.contractNumber;
      this.downloadParam.contractFileName = this.contractDetailInfo.contractFileName;
      this.downloadParam.contractStatus = this.contractDetailInfo.contractStatus;
      this.downloadParam.gubun = "DA";
      downloadFile(this.downloadParam).then(response => {
        // poer.close()
        this.$refs.loading.end();
        if (response.rdata.rcode === 20000) {
          var downloadFileName = encodeURIComponent(
            response.rdata.downFileName
          );
          window.open(
            this.url.confirmDownloadURL +
              "/" +
              this.downloadParam.gubun +
              "/" +
              response.rdata.convId +
              "/" +
              this.downloadParam.downloadUrl,
            "_blank"
          );
          this.getContractRecord();
        } else {
          this.$refs.confirm.open(
            "alert",
            "첨부파일 다운로드",
            "첨부파일 다운로드 요청에 실패했습니다. ( error : " +
              response.rdata.rmessage +
              " )"
          );
        }
      });
    },
    checkSignType() {
      if (this.contractDetailInfo.signType === 1) {
        this.$refs.pubCert.open();
      } else {
        this.submitAuthChain();
      }
    },
    // [2차 블록체인 인증] 마지막 블록체인 인증 창에서 확인 눌렀을 때
    submitAuthChain() {
      var changeStatusParam = this.paramsForChangeStatus();
      // 계약 승인과 승인 이외의 처리 프로세스 분리(검토승인 포함)
      if (this.authDialog.changeStatus === "CC") {
        this.$refs.loading.start("블록체인 인증 중입니다.");
        verifyChain(changeStatusParam)
          .then(response => {
            this.$refs.loading.end();
            if (response.rdata.rcode === 20000) {
              /* if (this.signal === 'BROKER') {
              // 여기는 기업 돈차감하는거 필요함
              this.changeStatusApprove(changeStatusParam)
              // alert(this.contractDetailInfo.ctrType.code)
            } else if (this.signal === 'PERSONAL') {
              this.changeStatusApprove(changeStatusParam)
            } */
              if (this.isV4(this.contractDetailInfo.contractNumber)) {
                // V4 계약승인
                this.approvalContractNomem(changeStatusParam);
              } else {
                // 기존 V3 계약승인
                this.changeStatusApprove(changeStatusParam);
              }
            } else if (response.rdata.rcode === 30011) {
              this.$refs.confirm.open(
                "alert",
                "계약 승인",
                "블록체인 인증에 실패했습니다. ( 실패이유 - " +
                  response.rdata.rmessage +
                  " )"
              );
            } else {
              this.$refs.confirm.open(
                "alert",
                "계약 승인",
                "블록체인 인증에 실패했습니다. 다시 시도하거나 관리자에게 문의해주세요."
              );
            }
          })
          .catch(e => {
            console.log(e);
          });
      } else {
        if (this.authDialog.changeStatus === "PC") {
          // 검토 승인일 경우
          this.changeStatusForReviewApprove(changeStatusParam);
        } else {
          if (this.isV4(this.contractDetailInfo.contractNumber)) {
            console.log("v4");
            if (this.authDialog.changeStatus === "CN") {
              console.log("v4 거부");
              // V4 계약 거부
              this.rejectContractNomem(changeStatusParam);
            } else {
              console.log("v4 거부가 아닌 경우");
              // 기존 V3 계약/검토 승인 외 상태변경 처리 (계약 거부 외 상태변경은 기존 상태변경 메서드를 타도록한다.)
              this.changeStatus(changeStatusParam);
            }
          } else {
            console.log("v3");
            // 기존 V3 계약/검토 승인 외 상태변경 처리
            this.$refs.confirm
              .open("confirm", "승인거부", "승인거부를 하시겠습니까?")
              .then(() => {
                this.changeStatus(changeStatusParam);
              });
          }
        }
      }
    },
    // V4 계약거부
    rejectContractNomem(changeStatusParam) {
      this.$refs.loading.start(this.authDialog.changeStatusText);
      rejectContractNomem(changeStatusParam)
        .then(response => {
          this.$refs.loading.end();
          if (response.rdata.rcode === 20000) {
            this.getContractRecord();
            this.$refs.confirm.open(
              "alert",
              "계약승인 거부",
              "계약승인이 거부 되었습니다."
            );
            this.sheet = false;
            this.$nextTick(() => {
              this.researchDatas();
            });
          } else if (response.rdata.rcode === 30011) {
            this.$refs.confirm.open(
              "alert",
              "계약승인 거부",
              "계약승인 거부에 실패했습니다. ( 실패이유 - " +
                response.rdata.rmessage +
                " )"
            );
          } else {
            this.$refs.confirm.open(
              "alert",
              "계약승인 거부",
              "계약승인 거부에 실패했습니다. 다시 시도하거나 관리자에게 문의해주세요."
            );
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    // [상태변경] 승인을 제외한 상태변경
    changeStatus(changeStatusParam) {
      this.$refs.loading.start(this.authDialog.changeStatusText);
      changeStatus(changeStatusParam)
        .then(response => {
          this.$refs.loading.end();
          if (response.rdata.rcode === 20000) {
            this.getContractRecord();
            this.$refs.confirm.open(
              "alert",
              this.authDialog.title,
              this.authDialog.endMessage
            );
            this.sheet = false;
            this.$nextTick(() => {
              this.researchDatas();
            });
          } else if (response.rdata.rcode === 30011) {
            this.$refs.confirm.open(
              "alert",
              this.authDialog.title,
              this.authDialog.title +
                "에 실패했습니다. ( 실패이유 - " +
                response.rdata.rmessage +
                " )"
            );
          } else {
            this.$refs.confirm.open(
              "alert",
              this.authDialog.title,
              this.authDialog.title +
                "에 실패했습니다. 다시 시도하거나 관리자에게 문의해주세요."
            );
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    changeStatusForReviewApprove(changeStatusParam) {
      this.$refs.loading.start(this.authDialog.changeStatusText);
      changeStatusForReviewApprove(changeStatusParam)
        .then(response => {
          this.$refs.loading.end();
          if (response.rdata.rcode === 20000) {
            this.chainAuthDialogVisible = false;
            this.$refs.confirm.open(
              "alert",
              this.authDialog.title,
              this.authDialog.endMessage
            );
          } else if (response.rdata.rcode === 30011) {
            this.$refs.confirm.open(
              "alert",
              this.authDialog.title,
              this.authDialog.title +
                "에 실패했습니다. ( 실패이유 - " +
                response.rdata.rmessage +
                " )"
            );
          } else {
            this.$refs.confirm.open(
              "alert",
              this.authDialog.title,
              this.authDialog.title +
                "에 실패했습니다. 다시 시도하거나 관리자에게 문의해주세요."
            );
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    // [상태변경] 승인
    changeStatusApprove(changeStatusParam) {
      this.$refs.loading.start(this.authDialog.changeStatusText);
      changeStatusForApprove(changeStatusParam)
        .then(response => {
          this.$refs.loading.end();
          if (response.rdata.rcode === 20000) {
            /*
          this.chainAuthDialogVisible = false
          var orgTotalPoint = response.rdata.orgTotalPoint
          var companyAmount = response.rdata.companyAmount
          if (this.signal === 'BROKER') {
            this.approveResultDialog(companyAmount, orgTotalPoint, 'storage')
          } else if (this.signal === 'PERSONAL') {
            this.openAlertMessage(this.authDialog.endMessage, this.authDialog.title, 'storage')
          }
          */
            this.$refs.confirm.open(
              "alert",
              this.authDialog.title,
              this.authDialog.endMessage
            );
            this.getContractRecord();
            this.sheet = false;
          } else if (response.rdata.rcode === 30011) {
            this.openAlertMessage(
              this.authDialog.title +
                "에 실패했습니다. ( 실패이유 - " +
                response.rdata.rmessage +
                " )",
              this.authDialog.title,
              ""
            );
          } else {
            this.openAlertMessage(
              this.authDialog.title +
                "에 실패했습니다. 다시 시도하거나 관리자에게 문의해주세요.",
              this.authDialog.title,
              ""
            );
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    // [상태변경] V4 계약승인
    approvalContractNomem(changeStatusParam) {
      this.$refs.loading.start(this.authDialog.changeStatusText);
      approvalContractNomem(changeStatusParam)
        .then(response => {
          this.$refs.loading.end();
          if (response.rdata.rcode === 20000) {
            this.$refs.confirm.open(
              "alert",
              this.authDialog.title,
              this.authDialog.endMessage
            );
            this.getContractRecord();
            this.sheet = false;
          } else if (response.rdata.rcode === 30011) {
            this.openAlertMessage(
              this.authDialog.title +
                "에 실패했습니다. ( 실패이유 - " +
                response.rdata.rmessage +
                " )",
              this.authDialog.title,
              ""
            );
          } else {
            this.openAlertMessage(
              this.authDialog.title +
                "에 실패했습니다. 다시 시도하거나 관리자에게 문의해주세요.",
              this.authDialog.title,
              ""
            );
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    // 상태변경을 위한 데이터를 만들어주는 함수 (중복이 되어서 따로 만듦)
    paramsForChangeStatus() {
      var changeStatusParam = {};
      changeStatusParam.chainAddr = this.contractDetailInfo.chainAddress;
      changeStatusParam.chainPass = this.contractDetailInfo.chainPassword;
      changeStatusParam.ctrNo = this.contractDetailInfo.contractNumber;
      changeStatusParam.ctrSeq = this.contractDetailInfo.contSeq;
      changeStatusParam.ctrStat = this.authDialog.changeStatus;
      changeStatusParam.rejectMsg = this.contractDetailInfo.rejectMsg;
      if (
        this.authDialog.changeStatus === "CC" ||
        this.authDialog.changeStatus === "PC" ||
        this.authDialog.changeStatus === "CN"
      ) {
        if (this.isWmAttach) {
          changeStatusParam.pdfFileName = this.$store.state.app.convertPdfName;
        } else {
          changeStatusParam.pdfFileName = this.convertedInfo.convertedCtrFileName;
        }
      }
      return changeStatusParam;
    },
    close() {
      this.getContractRecord();
      this.sheet = false;
      this.$nextTick(() => {
        this.researchDatas();
      });
    },
    purCertResult: function(vid, errorMessage, sign, certPEM) {
      this.errorMessage = errorMessage;
      if (vid) {
        this.submitAuthChain();
        this.dialogIdtest = false;
        this.sheet = false;
      } else {
        this.$refs.confirm.open("alert", "공동인증", errorMessage);
      }
    },
    chainPassResult: function(pass) {
      this.contractDetailInfo.chainPassword = pass;
      this.submitAuthChain();
    },
    rejectResult: function(msg) {
      this.contractDetailInfo.rejectMsg = msg;
      this.checkSignType();
    },
    CtrRecord(stat) {
      if (stat === "CR") {
        return "계약요청";
      } else if (stat === "CC") {
        return "계약승인";
      } else if (stat === "CA") {
        return "계약요청 취소";
      } else if (stat === "CN") {
        return "승인거부";
      } else if (stat === "PV") {
        return "미리보기";
      } else if (stat === "PR") {
        return "검토요청";
      } else if (stat === "PN") {
        return "검토거부";
      } else if (stat === "PC") {
        return "검토승인";
      } else if (stat === "DR") {
        return "폐기요청";
      } else if (stat === "DN") {
        return "폐기거부";
      } else if (stat === "DC") {
        return "폐기완료";
      } else if (stat === "DW" || stat === "DA") {
        return "다운로드";
      } else if (stat === "LA") {
        return "열람인증";
      }
    },
    getContractRecord() {
      getContractRecord({ ctrSeq: this.contractSeq })
        .then(response => {
          if (response.rdata.rcode === 20000) {
            this.contractHistory = response.rdata.contractHistory;
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    /* 파일첨부버튼 클릭 */
    clickUploadFile() {
      this.$refs.fileInput.value = "";
      this.$refs.fileInput.click();
    },
    changeUploadFile(e) {
      this.addAttachFile(e.target.files[0]);
    },
    addAttachFile(file) {
      this.$refs.confirm
        .open(
          "confirm",
          "파일 첨부",
          "<strong>" + file.name + "</strong>을 첨부하시겠습니까?"
        )
        .then(() => {
          if (this.verifyUploadFile(file)) {
            let formData = new FormData();
            formData.append("file", file);
            this.$refs.loading.start(
              "첨부 파일을 업로드 중 입니다. 잠시만 기다려주세요."
            );
            uploadFile(formData)
              .then(response => {
                this.$refs.loading.end();
                if (response.rcode === 20000) {
                  let formInfo = {
                    ctrSeq: this.contractDetailInfo.id,
                    ctrNo: this.contractDetailInfo.contractNumber,
                    convId: response.rdata.convId,
                    oriFileName: response.rdata.oriFileName
                  };
                  this.$refs.loading.start(
                    "첨부 파일을 전송 중 입니다. 잠시만 기다려주세요."
                  );
                  sendAttachFile(formInfo)
                    .then(response => {
                      this.$refs.loading.end();
                      if (response.rcode === 20000) {
                        this.$refs.confirm.open(
                          "alert",
                          "파일 첨부",
                          "첨부 파일이 전송되었습니다."
                        );
                      } else {
                        this.$refs.confirm.open(
                          "alert",
                          "파일 첨부",
                          "첨부 파일 전송에 실패했습니다."
                        );
                      }
                    })
                    .catch(() => {
                      this.$refs.loading.end();
                      this.$refs.confirm.open(
                        "alert",
                        "파일 첨부",
                        "첨부 파일 전송에 실패했습니다."
                      );
                    });
                } else {
                  this.$refs.confirm.open(
                    "alert",
                    "파일 첨부",
                    "첨부 파일 업로드를 실패했습니다."
                  );
                }
              })
              .catch(e => {
                console.error(e);
                this.$refs.loading.end();
                this.$refs.confirm.open(
                  "alert",
                  "파일 첨부",
                  "첨부 파일 업로드를 실패했습니다."
                );
              });
          }
        });
    },
    getAddress(address) {
      var orgname = this.$store.state.user.orgname;
      var orgaddr = this.$store.state.user.orgaddr;
      var useraddr = this.$store.state.user.useraddr;
      if (orgname) {
        if (orgaddr === address) {
          return true;
        } else {
          return false;
        }
      } else {
        if (useraddr === address) {
          return true;
        } else {
          return false;
        }
      }
    },
    // 수신자 승인여부에 따른 className
    receiverListClass(status) {
      let className = "";
      switch (status) {
        case 0:
          // 대기
          className = "";
          break;
        case 1:
          // 승인
          className = "ing_true";
          break;
        case 2:
          // 거부
          className = "ing_false";
          break;
        default:
      }
      return className;
    },

    /* 파일 유효성 검사 */
    verifyUploadFile(file) {
      var fileNameSize = file.name.length;
      var lastDotIndex = file.name.lastIndexOf(".");
      var fileExt = file.name
        .substring(lastDotIndex + 1, fileNameSize)
        .toLowerCase();
      var verify = true;
      // 허용된 파일 확장자인지 검사
      if (this.accessFileExtensions.indexOf(fileExt) === -1) {
        verify = false;
        this.$refs.confirm.open(
          "alert",
          "첨부파일 업로드",
          "업로드 파일의 확장자를 확인해주세요. (허용된 확장자 : " +
            this.accessFileExtensions.map(s => " ." + s).toString() +
            ")"
        );
      }
      return verify;
    },
    // V4 사용하는 계약번호
    isV4(ctrNo) {
      let result = false;
      if (ctrNo.length === 22) {
        result = true;
      } else if (ctrNo.indexOf("KRH-") >= 0 || ctrNo.indexOf("PMO-") >= 0) {
        result = true;
      }
      return result;
    }
  }
};
</script>
<style scoped></style>
